import { useState, Fragment } from "react"
import PropTypes from "prop-types"
import { map } from "lodash"
import { Popover } from "@mui/material"
import { Info } from "@mui/icons-material"
import "./style.scss"

export default function ResourceTooltipInfo({ alias, label, info }) {
  const [infoAnchor, setInfoAnchor] = useState(null)

  const openInfo = e => setInfoAnchor(e.currentTarget)
  const closeInfo = () => setInfoAnchor(null)

  const renderInfo = (item, i) => {
    if (item.values) {
      return <Fragment key={i}>
        <li className="resource-info-label">{item.label}</li>
        {map(item.values, (item, j) =>
          <li key={j} className={item.className}>
            <span className="resource-values-label">{item.label}</span>
            <span className="resource-values-value">{item.value}</span>
          </li>,
        )}
      </Fragment>
    } else if (item.value) {
      return <Fragment key={i}>
        <li className="resource-info-label">{item.label}</li>
        <li className={item.className}>{item.value}</li>
      </Fragment>
    }

    return <li key={i} className="resource-info-label">{item.label}</li>
  }

  return <div className="components_resource-tooltip-info resource-info-wrapper">
    <Info onMouseEnter={openInfo} onMouseLeave={closeInfo} />
    <Popover
      open={!!infoAnchor}
      anchorEl={infoAnchor}
      style={{ pointerEvents: "none" }}
      anchorOrigin={{ vertical: "bottom", horizontal: "left" }}
      transformOrigin={{ vertical: "top", horizontal: "left" }}
      onClose={closeInfo}
      disableRestoreFocus
    >
      <ul className="resource-info">
        {label && <li>{label}</li>}
        {alias && <>
          <li className="alias-label">Alias</li>
          <li>{alias}</li>
        </>}
        {map(info, renderInfo)}
      </ul>
    </Popover>
  </div>
}

ResourceTooltipInfo.propTypes = {
  alias: PropTypes.string,
  label: PropTypes.string,
  info: PropTypes.array.isRequired,
}
